import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import NavActions from '../../actions';

@pureRender
export default class SearchExtension extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: ''
        };

        this.listenerOn = false;
    }

    static propTypes = {
        active: PropTypes.bool,
        onSearch: PropTypes.func,
        hideSearch: PropTypes.func,
        searchMaxWidth: PropTypes.number
    };

    static contextTypes = {
        messages: PropTypes.object,
        isMobile: PropTypes.bool,
        isDesktop: PropTypes.bool,
        isTablet: PropTypes.bool
    };


    addListener() {
        //Add a click listener anywhere on the page which will close the dropdown
        if (!this.listenerOn) {
            document.body.addEventListener('click', this.closeSearch);
            document.body.addEventListener('touchend', this.closeSearch);
            this.listenerOn = true;
        }
    }

    removeListener() {
        //remove the click listener
        if (this.listenerOn) {
            document.body.removeEventListener('click', this.closeSearch);
            document.body.removeEventListener('touchend', this.closeSearch);
            this.listenerOn = false;
        }
    }

    //move up parent nodes of target and see if any have id #search
    isValidClick(e) {
        let n = e ? e.target : null;
        if (!n) return false;

        let isValid = false;

        const checkId = () => {
            if (n.id === 'search') {
                isValid = true;
                return true;
            }

            //top of the tree and escape
            if (!n.parentNode || n.parentNode.tagName.toUpperCase() === 'BODY') {
                return false;
            }

            n = n.parentNode;
            checkId();
            return undefined;
        };

        checkId();

        return isValid;
    }

    closeSearch = (e) => {
        if (!this.isValidClick(e)) {
            if (e && e.target) {
                if (e.target.className !== 'search-input' || (e.target.firstChild && e.target.firstChild.className !== 'search-input')) {
                    NavActions.searchActive.defer(false);

                    //change focus to close keyboard on mobile
                    try {
                        this.searchTextRef.focus();
                    } catch (ex) {
                        if (process.env.NODE_ENV !== 'production') {
                            console.warn('failed to find searchText ref');
                        }
                    }
                }
            }
        }
    };

    clearSearchText() {
        if (this.state.searchText !== '') {
            this.setState({
                searchText: ''
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.active) {
            //this.clearSearchText();
        }

        if (!this.listenerOn && nextProps.active) {
            this.addListener();
        }

        if (this.listenerOn && !nextProps.active) {
            this.removeListener();
        }
    }

    componentWillUnmount() {
        this.removeListener();

        NavActions.searchActive(false);
    }

    componentDidUpdate() {
        this.setFocus();
    }

    componentDidMount() {
        this.setFocus();
    }

    setFocus() {
        if (this.props.active) {
            try {
                this.searchTextRef.focus();
            } catch (e) {
                if (process.env.NODE_ENV !== 'production') {
                    console.warn('failed to find searchText ref');
                }
            }
        }
    }

    onSearch = (e) => {
        if (this.props.onSearch && typeof this.props.onSearch === 'function') {
            setTimeout(() => {
                this.props.onSearch(this.state.searchText);
                if (this.context.isMobile) {
                    NavActions.closeMobileTablet();
                }
            }, 10);
        }
    };

    onFocus = (e) => {
        if (this.context.isMobile) {
            NavActions.searchActive(true);
        }
    };

    setSearch = (e) => {
        this.setState({
            searchText: e.currentTarget.value
        });
    };

    onKeyDown = (e) => {
        if (e && e.keyCode === 13) { //enter
            setTimeout(() => {
                this.onSearch();
            }, 10);
        }
    };

    render() {
        const active = this.props.active;

        let searchBoxActiveClass = 'search closed';
        if (active && this.context.isMobile) {
            searchBoxActiveClass = 'search active focus';
        } else if (active || this.context.isMobile) {
            searchBoxActiveClass = 'search active';
        }

        const messages = this.context.messages || {};
        const hidden = !this.state.searchText || this.state.searchText.length < 1 ? 'hidden' : '';

        let searchMaxWidth;
        if (this.context.isTablet && this.props.searchMaxWidth) {
            searchMaxWidth = this.props.searchMaxWidth;
        }

        return (
            <div
                id="form"
                className={searchBoxActiveClass}
                style={searchMaxWidth ? { maxWidth: searchMaxWidth } : null}>

                <div className="form-inline">
                    <div className="form-group">
                        <input
                            type="search"
                            name="keyword"
                            id="query"
                            aria-label={messages.search}
                            ref={(c) => {this.searchTextRef = c;}}
                            placeholder={messages.search_bar}
                            className="search-input text-color"
                            onChange={this.setSearch}
                            onFocus={this.onFocus}
                            onKeyDown={this.onKeyDown}
                            value={this.state.searchText} />
                        <input
                            type="hidden"
                            name="limit"
                            value="all" />
                    </div>
                    <div className={`search-btn search-btns ${hidden}`}>
                        <a
                            tabIndex="0"
                            role="button"
                            onClick={this.onSearch}
                            title={messages.search}>
                            <i className="eg-header-icon-search" />
                        </a>
                    </div>
                    {!this.context.isMobile ?
                        <div className={'close-btn search-btns'}>
                            <a role="button" tabIndex="-1" onClick={this.props.hideSearch}>
                                <i className={'eg-header-icon-close'} />
                            </a>
                        </div>
                        : ''}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/search/SearchExtension.js